import RemoteEduMenu from './RemoteEduMenu.vue';

export * from './types';
export default RemoteEduMenu;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/remotemenu/index.ts